<template>
	<v-card>
		<v-card-text class="pa-0">
			<!-- <v-divider></v-divider> -->
			<v-data-table
			    dense
			    hide-default-footer
			    fixed-header
			    show-select
			    v-model="infoToFilter.deviceSelecteds"
			    :headers="headers"
			    :items="renderList"
			    :items-per-page="50"
			    class="elevation-1"
			    height="200"
			    item-key="id"
			>
				<template v-slot:header.name="{ header }">
			      {{ $ml.get(header.text).toUpperCase() }}
			    </template>
			    <template v-slot:header.range="{ header }">
			      {{ $ml.get(header.text) }}
			    </template>
			    <template v-slot:item.range="{item, index}">
			    	<MenuDateTimes
			  			:inputField="item.range"  			
			  			keyFieldDates="dates"			
			  			:isXSmall="true"
			  			:isLabel="true"			  			
			  			:isMultiple="true"
			  			:key="index+'range_device_MenuDateTimes'"
			  			:reference="index+'ref_range_device_MenuDateTime'"
			  			
			  		></MenuDateTimes>
			  			<!-- @receiveConfirm="refreshComponent()" -->
			    </template>
			</v-data-table>
			<v-item-group v-if="false">
				<v-container fluid class="pt-0 overflow-y-auto">
					<v-row dense class="fill-height" style="max-height: 300px;">
						<v-col 
							v-for  	= "(itemDevice, idxDevice) of renderList" 
							:key 	= "'list_device_sidebar' + idxDevice" 
							cols 	= "auto"  
						>
							<!-- @click 	="sel(n)"  -->
							<v-item v-slot:default = "{ active, toggle }">
								<v-card 
									dark  
									outlined
									:color 	= "active  ? 'primary' : '' "  
									style 	= "width:100px; height: 100%;"  
									@click 	= "toggle" 
									class 	= "pl-0 ma-0" 
								>	
									<v-card-title class = "pa-0 ma-0 primary" style = "font-size: 80%; line-height: 110%">
										<!-- <v-spacer></v-spacer> -->
										{{ itemDevice.name }}
									</v-card-title>																		
										<!-- <v-tooltip top>
													<template v-slot:activator = "{ on }">
														<v-btn
															fab												
															color   = "error"
															@click  = "deleteFaceItem(itemDevice)"
															width   = "20"
															height  = "20" 
															v-on 	= "on"
														>
															<v-icon small color="white"> mdi-delete </v-icon>
														</v-btn>
													</template>
													<span> {{ $ml.get('delete') }} </span>		
												</v-tooltip> -->		
							            <v-card-actions style = "font-size: 80%; line-height: 110%">
							            	<!-- <span> {{ $ml.get('face') }} #{{idxDevice}}</span><br> -->
											<!-- <span> {{ itemDevice.msg }}</span> -->
							            </v-card-actions>										             	
									</v-card>
								</v-item>
							</v-col>
						</v-row>	
					</v-container>
					
				</v-item-group>
			<v-divider></v-divider>
		</v-card-text>
		<v-card-actions class="text-h5">
			<strong class=" mt-2">			
				# {{  renderList.length }}
			</strong>
			
			
		</v-card-actions>
	</v-card>
</template>
<script type="text/javascript">
 	import MenuDateTimes from "@/components/info/MenuDateTimes.vue"
	export default{
		name: "SidebarFaces",
		components:{MenuDateTimes},
		props:["infoToFilter"],
		data: ()=>({
			loading:false,
			messageErrorUpload: [],
			headers : [
				{ text : "device", value: "name"},
				{ text : "range", value: "range"},
			],
		}),
		computed:{
			renderList(){
				return this.$store.getters["Devices/list"].map(x=>{
					if(x){
						return {
							id: x.id,
							name: x.name,
							deviceId: x.deviceId,
							range : {dates: this.$Helper.formatDatePicker(), start: "00:00", end: "23:59"},
						}
					}
				});
			}
		},
		methods:{
			triggerFileInput(){				
				this.$refs.uploadImage.$el.querySelector('input[type="file"]').click();
			},
			deleteItem(item){
				this.infoItem=item;
				const idx = this.renderList.indexOf(item);				
			},
					}, // methods
	}
</script>